import GetAllowedOrderStatuses from "../hooks/fetch-hooks/fetch-all/get-all-order-allowed-statuses";
import Cookies from "js-cookie";
import { request } from "../config/helpers/axios-instance";
import _ from 'lodash'

export const getOrderStatuses = () => {
    const { data: response } = GetAllowedOrderStatuses();
    if (response?.data?.success) {
        return response.data.data
    }
}

export const getQuotationStatuses = () => {
    return ['ACTIVE', 'PENDING', 'CANCELLED', 'PAYMENT_PENDING']
}

export const getUserRoles = () => {
    const roles = Cookies.get("roles");
    if (roles) {
        return JSON.parse(roles);
    }
    return [];
}

export const getTenantId = () => {
    const tenantId = Cookies.get("tenantId");
    return tenantId;
}

export async function verifyCaptcha(phone, token) {
    try {
        const res = await request({
            method: "POST",
            url: `user/validateCaptcha`,
            data: {
                captchaToken: token,
                username: phone
            },
            headers: {
                "app-version": "100.0",
                "Content-Type": "application/json",
                "ngrok-skip-browser-warning": "100.0"
            }
        })

        if (res.status === 200 && res.data && res.data.success) {
            return true
        }

        return false
    } catch (error) {
        console.log(error)
        return false
    }
}

export const logoutHelper = () => {
    Cookies.remove("user");
    Cookies.remove("token");
    Cookies.remove("refresh_token")
    Cookies.remove("token_expires_at")
    Cookies.remove("roles")
    window.location.reload();
}

export const titleCase = (str) => {
    return _.startCase(_.lowerCase(str))
}

// documentType drives the prefix: INVOICE → SVC, CREDIT_NOTE → CN
// financialYear "2026-27" → "2627" (last 2 digits of each year, dash dropped)
export const formatGstSerial = (paymentItem) => {
    const { documentType, serialNumber, financialYear } = paymentItem;
    if (serialNumber == null || !financialYear) return null;
    const prefix = documentType === 'CREDIT_NOTE' ? 'CN' : 'INV';
    const [y1, y2] = financialYear.split('-');
    const fyShort = `${y1.slice(-2)}${y2}`;
    const padded = String(serialNumber).padStart(4, '0');
    return `${prefix}/${fyShort}/${padded}`;
};
